import { Enums } from '@flightscope/baseball-stats';


/**
 * @typedef {{key: string, name: string}} EnumItem
 */

/** @type {Record<string, EnumItem>} */
const CustomPitchCall = {
  ContactOut: { key: 'CO', name: 'Contact Out' },
  BallInPlay: { key: 'BP', name: 'Hit' },
};
/**
 * @typedef {keyof Enums.PitchCall} OrigPitchCallKeys
 * @typedef {keyof CustomPitchCall} CustomPitchCallKeys
 * @typedef {OrigPitchCallKeys | CustomPitchCallKeys} PitchCallKeys
 *
 * @typedef {Record<PitchCallKeys, EnumItem>} PitchCallEnum
 */

/** @type {PitchCallEnum} */
const PitchCall = {
  ...Enums.PitchCall,
  ...CustomPitchCall,
};

export default PitchCall;
